module.exports = {
  isExtraSmall: window.matchMedia("(max-width: 489px)"),
  isSmall: [ window.matchMedia("(max-width:681px)"),
              window.matchMedia("(min-width: 490px)")],
  isMedium:[ window.matchMedia("(max-width:850px)"),
            window.matchMedia("(min-width: 682px)")],
  isLarge: window.matchMedia("(min-width: 851px)")
};